import React from "react";

function InputGroup({
  percentage,
  setPercentage,
  present,
  setPresent,
  total,
  setTotal,
  onCalculate,
}) {
  return (
    <div className="space-y-6">
      {/* Percentage Dropdown */}
      <div className="flex flex-col space-y-2">
        <label htmlFor="percentage" className="text-lg font-medium text-gray-600">
          Percentage Required
        </label>
        <select
          id="percentage"
          value={percentage}
          onChange={(e) => setPercentage(e.target.value)}
          className="border border-gray-300 rounded-md p-4 focus:ring-2 focus:ring-blue-300 focus:outline-none"
        >
          <option value="50">50%</option>
          <option value="55">55%</option>
          <option value="60">60%</option>
          <option value="65">65%</option>
          <option value="70">70%</option>
          <option value="75">75%</option>
          <option value="80">80%</option>
          <option value="85">85%</option>
          <option value="90">90%</option>
        </select>
      </div>

      {/* Present Input */}
      <div className="flex flex-col space-y-2">
        <label htmlFor="present" className="text-lg font-medium text-gray-600">
          Hours Attended
        </label>
        <input
          type="number"
          id="present"
          value={present}
          onChange={(e) => setPresent(e.target.value)}
          className="border border-gray-300 rounded-md p-4 focus:ring-2 focus:ring-blue-300 focus:outline-none"
        />
      </div>

      {/* Total Classes Input */}
      <div className="flex flex-col space-y-2">
        <label htmlFor="total" className="text-lg font-medium text-gray-600">
          Total Hours Held
        </label>
        <input
          type="number"
          id="total"
          value={total}
          onChange={(e) => setTotal(e.target.value)}
          className="border border-gray-300 rounded-md p-4 focus:ring-2 focus:ring-blue-300 focus:outline-none"
        />
      </div>

      {/* Calculate Button */}
      <div className="text-center mt-4">
        <button
          onClick={onCalculate}
          className="w-full py-3 px-4 bg-teal-500 text-white text-lg rounded-md shadow-lg hover:bg-teal-600 focus:outline-none focus:ring-4 focus:ring-blue-300"
        >
          Calculate
        </button>
      </div>
    </div>
  );
}

export default InputGroup;
